"use strict";

PF.Filter = class Filter extends PF.Entity
	{

	static get options()
		{
		return {
			type: 'filter',
			name: PF.H.randomString(),
			rule: '',
			conditions: {},
			root: undefined,
			parent: undefined,
			source: 'lr',
		};
		}

	init()
		{
		if (this.root === undefined)
			{
			this.root = this;
			}
		this.parse(this.rule);
		if (this.parent !== undefined)
			{
			if (this.source === 'lr')
				{
				this.on('change', () => this.parent.trigger('change'));
				}
			if (this.source === 'r')
				{
				this.on('change-r', () => this.parent.trigger('change-r'));
				}
			if (this.source === 'l')
				{
				this.on('change-l', () => this.parent.trigger('change-l'));
				}
			}
		}

	parse(string)
		{
		let rule = string;
		let conditions = {};
		let conditionsStrings = string.split(/\(|\)|&&|\|\|/);
		for (let i = 0; i < conditionsStrings.length; i++)
			{
			let conditionString = conditionsStrings[i].trim();
			if (conditionString.length === 0)
				{
				continue;
				}
			let isCondition = false;
			for (let operator in PF.Condition.comparePattern)
				{
				if (conditionString.indexOf(` ${operator} `) > 0)
					{
					let parts = conditionString.split(operator);
					let field = parts[0].trim();
					let value = parts[1].trim();
					let name = field.replace(/ /g, '_') + '_' + PF.H.randomString(5);
					this.conditions[name] = this.createCondition({
						type: 'condition',
						field: field,
						value: value,
						operator: operator,
						name: name,
						parent: this,
						root: this.root,
					});
					rule = rule.replace(conditionString, ` ${name} `);
					isCondition = true;
					}
				}
			if (isCondition === false)
				{
				this.conditions[conditionString] = this.createCondition({
					type: 'filter',
					name: conditionString.replace(' ', '_'),
					rule: '',
					root: this.root,
					parent: this,
				});
				}
			}
		this.rule = rule;
		}

	// findDepends(string)
	// 	{
	// 	let offset = 0;
	// 	let depends = [];
	// 	while (string.indexOf('@{', offset) > -1)
	// 		{
	// 		let begin = string.indexOf('@{', offset) + 2;
	// 		let end = string.indexOf('}', begin);
	// 		depends.push({
	// 			object: this.root,
	// 			key: string.substring(begin, end)
	// 		});
	// 		offset = begin + 1;
	// 		}
	// 	return depends;
	// 	}

	createCondition(conditionConfig, name = null)
		{
		let condition;
		if (conditionConfig.type === 'filter')
			{
			condition = new PF.Filter(conditionConfig);
			}
		if (conditionConfig.type === 'condition')
			{
			condition = new PF.Condition(conditionConfig);
			}

		return condition;
		}

	and(rule, source = 'lr')
		{
		// if(typeof rule === 'string')
		// 	{
		let filter = new PF.Filter({rule: rule, root: this.root, source: source, parent: this});
		this.conditions[filter.name] = filter;
		this.addRule('&&', filter.name);
		// 	}
		// if(typeof rule === 'object')
		// 	{
		// 	let filter = new PF.Filter({...rule, root: this.root, source: source, parent: this});
		// 	this.conditions[filter.name] = filter;
		// 	this.addRule('&&', filter.name);
		// 	}
		}

	or(rule, source = 'lr')
		{
		let filter = new PF.Filter({rule: rule, root: this.root, source: source, parent: this});
		this.conditions[filter.name] = filter;
		this.addRule('||', filter.name);
		}

	// andCondition(condition)
	// 	{
	// 	condition = this.createCondition(condition);
	// 	this.addRule('&&', condition.name);
	// 	}
	//
	// orCondition(condition)
	// 	{
	// 	condition = this.createCondition(condition);
	// 	this.addRule('||', condition.name);
	// 	}

	addRule(operator, name)
		{
		if (this.rule.length > 0)
			{
			this.rule += ` ${operator} ${name} `;
			}
		else
			{
			this.rule = name;
			}
		}

	static concatRule(rule, operator, condition)
		{
		if (rule.length > 0)
			{
			rule += ` ${operator} ${condition} `;
			}
		else
			{
			rule = condition;
			}
		return rule;
		}

	check(object)
		{

		let rule = this.rule;
		if (rule === '')
			{
			return true;
			}
		for (let name in this.conditions)
			{
			let conditionResult = this.conditions[name].check(object);
			rule = rule.replace(name, conditionResult.toString());
			}
		rule = rule.trim();
		if (rule === '')
			{
			return true;
			}
		return eval(rule);
		}

	toJSON(source = 'r')
		{
		let conditions = [];
		if (this.source.indexOf(source) < 0)
			{
			return {
				name: this.name,
				rule: " TRUE ",
				conditions: [],
				type: 'filter'
			};
			}

		for (let name in this.conditions)
			{
			conditions.push(this.conditions[name].toJSON(source));
			}
		return {
			name: this.name,
			rule: this.rule,
			path: this.path,
			conditions: conditions,
			type: 'filter'
		};
		}


	static appendRule(rule, operator, name = PF.H.randomString())
		{
		if (rule.length > 0)
			{
			rule += ` ${operator} ${name} `;
			}
		else
			{
			rule = name;
			}
		return rule;
		}

	destroy()
		{
		super.destroy();
		for (let key in this.conditions)
			{
			this.conditions[key].destroy();
			}
		}
	};

PF.Condition = class Condition extends PF.Entity
	{
	static get options()
		{
		return {
			name: PF.H.randomString(),
			field: undefined,
			value: '',
			operator: 'unknown',
			depend: [], //{object: , key: , debounce}
		};
		}

	init()
		{
		this.compare = PF.Condition.comparePattern[this.operator].bind(this);
		this.calcString('value', this.root.models);
		this.onChange('value', () => {
			// console.log('filter change value: ', this.value);

			if (this.parent.source === 'lr')
				{
				this.parent.trigger('change');
				}
			if (this.parent.source === 'r')
				{
				this.parent.trigger('change-r');
				}
			if (this.parent.source === 'l')
				{
				this.parent.trigger('change-l');
				}
		});

		}

	check(object)
		{
		let objectValue = object.applyContext(this.field);
		let conditionValue = this.value;//PF.applyContext(this.value, this.root, '', '');
		this.compare = this.compare.bind(this);
		return this.compare(objectValue, conditionValue, object);
		}

	static get comparePattern()
		{
		return {
			'unknown': () => true,
			'===': (objectValue, conditionValue) => objectValue === conditionValue,
			'!==': (objectValue, conditionValue) => objectValue !== conditionValue,
			'==': (objectValue, conditionValue) => objectValue == conditionValue,
			'!=': (objectValue, conditionValue) => objectValue != conditionValue,
			'>': (objectValue, conditionValue) => objectValue > conditionValue,
			'<': (objectValue, conditionValue) => objectValue < conditionValue,
			'>=': (objectValue, conditionValue) => objectValue >= conditionValue,
			'<=': (objectValue, conditionValue) => objectValue <= conditionValue,
			'~': (objectValue, conditionValue) => {
				objectValue = objectValue.toString().toLowerCase();
				conditionValue = conditionValue.toString().toLowerCase().trim();
				return objectValue.indexOf(conditionValue) > -1;
			},
			'!~': (objectValue, conditionValue) => {
				objectValue = objectValue.toString().toLowerCase();
				conditionValue = conditionValue.toString().toLowerCase().trim();
				return objectValue.indexOf(conditionValue) < 0;
			},
		};
		}

	toJSON()
		{
		return {
			name: this.name,
			field: this.field,
			value: this.value,//PF.applyContext(this.value, this.root, '', ''),
			operator: this.operator,
			type: 'condition'
		};
		}
	};